/* GENERATED by scripts/gen-data.mjs — chapter "production" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_PRODUCTION: NodeDef = {
  "id": "production",
  "tagKey": "path:production.tag",
  "x": 320,
  "y": 560,
  "w": 220,
  "h": 116,
  "titleKey": "path:production.title",
  "subKey": "path:production.sub",
  "blocks": [
    {
      "id": "production.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:production.b1.title",
      "bodyKey": "path:production.b1.body",
      "flowKey": "path:production.b1.flow"
    },
    {
      "id": "production.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:production.b2.title",
      "film": "f-production"
    },
    {
      "id": "production.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:production.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:production.b3o.opts.0.n",
            "wKey": "path:production.b3o.opts.0.w",
            "uKey": "path:production.b3o.opts.0.u",
            "cKey": "path:production.b3o.opts.0.c",
            "slug": "batch-offline"
          },
          {
            "nKey": "path:production.b3o.opts.1.n",
            "wKey": "path:production.b3o.opts.1.w",
            "uKey": "path:production.b3o.opts.1.u",
            "cKey": "path:production.b3o.opts.1.c",
            "slug": "synchronous-request"
          },
          {
            "nKey": "path:production.b3o.opts.2.n",
            "wKey": "path:production.b3o.opts.2.w",
            "uKey": "path:production.b3o.opts.2.u",
            "cKey": "path:production.b3o.opts.2.c",
            "slug": "async-human-review"
          },
          {
            "nKey": "path:production.b3o.opts.3.n",
            "wKey": "path:production.b3o.opts.3.w",
            "uKey": "path:production.b3o.opts.3.u",
            "cKey": "path:production.b3o.opts.3.c",
            "slug": "route-by-sensitivity"
          },
          {
            "nKey": "path:production.b3o.opts.4.n",
            "wKey": "path:production.b3o.opts.4.w",
            "uKey": "path:production.b3o.opts.4.u",
            "cKey": "path:production.b3o.opts.4.c",
            "slug": "cheaper-inference"
          },
          {
            "nKey": "path:production.b3o.opts.5.n",
            "wKey": "path:production.b3o.opts.5.w",
            "uKey": "path:production.b3o.opts.5.u",
            "cKey": "path:production.b3o.opts.5.c",
            "slug": "a-kill-switch"
          },
          {
            "nKey": "path:production.b3o.opts.6.n",
            "wKey": "path:production.b3o.opts.6.w",
            "uKey": "path:production.b3o.opts.6.u",
            "cKey": "path:production.b3o.opts.6.c",
            "slug": "canary-or-shadow-release"
          }
        ],
        "ref": "mltest"
      }
    },
    {
      "id": "production.b3",
      "kind": "tree",
      "xp": 20,
      "titleKey": "path:production.b3.title",
      "tree": {
        "qKey": "path:production.b3.tree.q",
        "branches": [
          {
            "tone": "stop",
            "aKey": "path:production.b3.tree.b.0.a",
            "verdictKey": "path:production.b3.tree.b.0.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:production.b3.tree.b.1.a",
            "verdictKey": "path:production.b3.tree.b.1.verdict"
          },
          {
            "tone": "pass",
            "aKey": "path:production.b3.tree.b.2.a",
            "verdictKey": "path:production.b3.tree.b.2.verdict"
          }
        ]
      }
    },
    {
      "id": "production.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:production.b4.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:production.b4.ex.options.0.t",
            "ok": false,
            "fbKey": "path:production.b4.ex.options.0.fb"
          },
          {
            "tKey": "path:production.b4.ex.options.1.t",
            "ok": true,
            "fbKey": "path:production.b4.ex.options.1.fb"
          },
          {
            "tKey": "path:production.b4.ex.options.2.t",
            "ok": false,
            "fbKey": "path:production.b4.ex.options.2.fb"
          }
        ]
      }
    }
  ]
};
